export default __webpack_public_path__ + "static/Peter_with_name-719cd4d9e3dece23fa6dc7d9eb23ce28.png";